import { render, staticRenderFns } from "./InactiveVendorsTable.vue?vue&type=template&id=2006bbc0&scoped=true"
import script from "./InactiveVendorsTable.vue?vue&type=script&lang=js"
export * from "./InactiveVendorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006bbc0",
  null
  
)

export default component.exports